import React, { useState, useEffect } from 'react';
import { getAboutUs } from '../../../services/userService';
import NoData from '../../../components/common/NoData';

function AboutUs() {
  const [aboutUs, setAboutUs] = useState([]);

  useEffect(() => {
    getAboutUsData();
  }, []);

  const getAboutUsData = async () => {
    try {
      const response = await getAboutUs();
      if (response.success && response.data?.response) {
        setAboutUs(response.data.response);
      } else {
        setAboutUs([]);
      }
    } catch (error) {
      console.error('Error fetching about us data:', error);
      setAboutUs([]);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-[var(--text-primary)] mb-1">About Us</h2>
        <p className="text-sm text-[var(--text-secondary)]">Learn more about our mission, values, and who we are.</p>
      </div>

      <div className="space-y-4">
        {aboutUs.length > 0 ? (
          aboutUs.map((item, index) => (
            <div
              className="rounded-xl border border-[var(--border-color)] bg-[var(--bg-secondary)]/50 p-5"
              key={index}
            >
              <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">{item.name}</h3>
              <p className="text-[var(--text-secondary)] leading-relaxed">{item.description}</p>
            </div>
          ))
        ) : (
          <NoData message="No About Us content available." />
        )}
      </div>
    </div>
  );
}

export default AboutUs;
